(() => {
  if (window.DFProduct) { window.DFProduct.init(document); return; }
  const bound = new WeakSet(), observers = new Map();
  function init(scope = document) {
    const sections = [...scope.querySelectorAll('[data-df-product-section]')];
    if (scope.matches?.('[data-df-product-section]')) sections.unshift(scope);
    sections.forEach(section => {
      if (bound.has(section)) return;
      bound.add(section);
      const id = section.dataset.dfProductSection;
      const form = document.getElementById(`product-form-${id}`);
      const dock = document.querySelector(`[data-df-purchase-dock="${id}"]`);
      const buy = form?.querySelector('[data-product-submit]');
      if (buy && dock && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          const entry = entries[0];
          dock.classList.toggle('visible', !entry.isIntersecting && entry.boundingClientRect.bottom < 0);
        }, { threshold: 0 });
        observer.observe(buy); observers.set(id, observer);
      }
      const select = form?.querySelector('[data-df-variant]');
      const json = document.querySelector(`[data-df-variants="${id}"]`);
      if (!select || !json) return;
      let variants;
      try { variants = JSON.parse(json.textContent); } catch { return; }
      select.addEventListener('change', () => {
        const variant = variants.find(item => String(item.id) === select.value);
        if (!variant) return;
        [section, dock].filter(Boolean).forEach(container => {
          container.querySelectorAll('[data-product-price]').forEach(node => { node.textContent = variant.price; });
          container.querySelectorAll('[data-product-submit]').forEach(button => {
            button.disabled = !variant.available;
            const label = button.querySelector('[data-submit-label]');
            if (label) label.textContent = variant.available ? button.dataset.addLabel : section.dataset.soldOut;
          });
        });
        const url = new URL(location.href); url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
        const gallery = section.querySelector('[data-product-gallery]');
        const panel = [...(gallery?.querySelectorAll('[data-media-id]') || [])].find(node => node.dataset.mediaId === String(variant.media_id));
        if (panel) gallery.querySelector(`[data-gallery-thumb="${panel.dataset.galleryPanel}"]`)?.click();
        form.dispatchEvent(new CustomEvent('df:variant-change', { bubbles: true, detail: { variant } }));
      });
    });
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-df-product-section]').forEach(section => {
      observers.get(section.dataset.dfProductSection)?.disconnect();
      observers.delete(section.dataset.dfProductSection);
    });
  });
  window.DFProduct = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
})();
